/**
 * Чек-лист: готовность компании к пилоту AI (ICP: COO, операционка, B2B)
 * Маршрут: /ready-for-ai
 * Опоры: данные, владелец процесса, интеграции (strategy.md)
 */
export const automationGoalOptions = [
  {
    value: 'drafts',
    label: 'Черновики, обучение, ответы без доступа к внутренним системам',
  },
  {
    value: 'actions',
    label: 'Простые действия: уведомления, справки из API, расчёты',
  },
  {
    value: 'open_research',
    label: 'Исследования по открытым источникам (рынок, регуляторика)',
  },
  {
    value: 'internal_kb',
    label: 'Поиск по регламентам, FAQ, онбординг по внутренним документам',
  },
  {
    value: 'multistep',
    label: 'Многошаговая работа с файлами и системами, путь заранее не расписан',
  },
  {
    value: 'production',
    label: 'Много задач подряд в работе - с проверкой и одобрением сотрудником',
  },
];

export const operationsChecklistData = {
  blocks: [
    {
      id: 0,
      title: 'Задача для пилота',
      pillar: 'use_case',
      scoring: false,
      description: 'Отметьте сценарии, которые сейчас в приоритете - по ним подберём уровень внедрения',
      icon: 5,
      questions: [
        {
          id: 'automation_goals',
          type: 'multi_choice',
          text: 'Что сейчас в приоритете автоматизировать с помощью ИИ? (можно несколько)',
          options: automationGoalOptions,
        },
      ],
    },
    {
      id: 1,
      title: 'Данные и комплаенс',
      pillar: 'data',
      description: 'Понятно ли, какие данные участвуют в пилоте и кто отвечает за режим обработки',
      icon: 0,
      questions: [
        { id: 1, text: 'Определены массивы данных, которые можно использовать в пилоте ИИ?' },
        { id: 2, text: 'Понятно, где в данных персональная или чувствительная информация и как её обрабатывать?' },
        { id: 3, text: 'Есть правило: что нельзя выгружать во внешние сервисы без согласования?' },
        { id: 4, text: 'Назначен ответственный за утверждение режима обработки данных для пилота?' },
      ],
    },
    {
      id: 2,
      title: 'Владелец и метрика',
      pillar: 'owner',
      description: 'Кто отвечает за эффект в операции, а не только за демо в ИТ',
      icon: 1,
      questions: [
        { id: 5, text: 'Есть владелец процесса из операционного блока (не только ИТ)?' },
        { id: 6, text: 'Сформулирована одна измеримая метрика успеха пилота на горизонт 4-8 недель?' },
        { id: 7, text: 'ИТ подключается к пилоту, но не является единственным драйвером инициативы?' },
        { id: 8, text: 'Руководство понимает, что пилот - проверка гипотезы, а не обязательство масштабировать любой результат?' },
      ],
    },
    {
      id: 3,
      title: 'Интеграции и после пилота',
      pillar: 'integrations',
      description: 'Что происходит с процессом на проде после демо',
      icon: 2,
      questions: [
        { id: 9, text: 'Понятен первый рабочий контур (CRM, ERP, тикеты, 1С) для интеграции?' },
        { id: 10, text: 'Есть план: что будет с потоком на проде, если пилот успешен?' },
        { id: 11, text: 'Определены поддержка и SLA после пилота (хотя бы черновик)?' },
        { id: 12, text: 'Используется CRM или система учёта заявок (например, Битрикс24)?' },
      ],
    },
    {
      id: 4,
      title: 'Команда и инструменты',
      pillar: 'team',
      description: 'Дисциплина данных и готовность команды к обучению',
      icon: 3,
      questions: [
        { id: 13, text: 'В команде есть люди, готовые пройти короткое обучение по работе с ИИ (2-4 часа)?' },
        { id: 14, text: 'Документация и регламенты по процессу пилота не разбросаны только в чатах?' },
        { id: 15, text: 'Есть ответственный за координацию между операциями, ИТ и вендором?' },
      ],
    },
    {
      id: 5,
      title: 'Бюджет и приоритет',
      pillar: 'budget',
      description: 'Реалистичные ожидания и ресурс на интеграции, не только лицензии',
      icon: 4,
      questions: [
        { id: 16, text: 'В бюджете заложены интеграции и сопровождение, а не только подписка на модель?' },
        { id: 17, text: 'Есть поддержка руководства на эксперимент с понятной датой ревью пилота?' },
        { id: 18, text: 'Команда понимает: ИИ не заменяет владельца процесса и не даёт гарантированный ROI без измерений?' },
      ],
    },
  ],
};

export const operationsChecklistMeta = {
  questionCount: 19,
  maxScore: 36,
  scaleMax: 2,
};

export const operationsPillarLabels = {
  data: 'Данные и комплаенс',
  owner: 'Владелец и метрика',
  integrations: 'Интеграции и после пилота',
  team: 'Команда и инструменты',
  budget: 'Бюджет и приоритет',
};
